import ccSession from 'cc-session'

import { currentUser } from '../redux/auth/selectors'
import { store } from '../redux/store'

const session: typeof ccSession = () => currentUser(store.getState()).sessionToken

export default session
